import Dexie from 'dexie'

const db = new Dexie('infibo-admin')
db.version(1).stores({
    keeper_log: '++id,account_id,name,command,ticket,symbol,type,lots,profit,comment,magic,buy_lots,sell_lots,price,drawdown,open_time'
})

export default db
